import { Link } from 'react-router-dom';
import { heroStats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[700px] md:min-h-[800px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20epic%20fantasy%20landscape%20with%20warm%20sunset%20golden%20lighting%2C%20dramatic%20clouds%2C%20ancient%20temple%20in%20distance%2C%20artistic%20painterly%20style%2C%20rich%20warm%20amber%20and%20deep%20brown%20tones%2C%20atmospheric%20and%20dreamy%20mood%2C%20beautiful%20composition%20suitable%20for%20hero%20banner&width=1800&height=1000&seq=hero-bg-main&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-4 py-1.5 mb-8 border border-white/20">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-sm text-white/90 font-medium">每日更新 86 部 · 持续汉化中</span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight max-w-4xl mx-auto">
            发现你的
            <span className="text-accent-400">下一部</span>
            <br />
            心头好韩漫
          </h1>

          <p className="mt-6 text-base md:text-lg text-white/70 max-w-2xl mx-auto leading-relaxed">
            韩漫吧汇聚全网优质韩漫资源，下拉式流畅阅读体验，
            <br className="hidden sm:block" />
            让每一话都成为一种享受。免费、高清、日日更新。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
            <Link
              to="/category/fantasy"
              className="bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-base font-medium whitespace-nowrap hover:bg-primary-600 transition-all duration-200 hover:scale-105"
            >
              立即探索
              <span className="w-5 h-5 inline-flex items-center justify-center ml-2">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-full text-base font-medium whitespace-nowrap text-white border border-white/30 hover:bg-white/10 transition-all duration-200"
            >
              了解更多
            </Link>
          </div>

          <div className="grid grid-cols-3 gap-6 md:gap-12 mt-16 max-w-2xl mx-auto">
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold font-heading text-white">{heroStats.totalComics.toLocaleString()}+</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">漫画资源</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold font-heading text-accent-400">{heroStats.dailyUpdates}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">日均更新</div>
            </div>
            <div className="text-center">
              <div className="text-3xl md:text-4xl font-bold font-heading text-white">{heroStats.activeReaders.toLocaleString()}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">活跃读者</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-6">
        <div className="flex gap-2 md:gap-3">
          <div className="w-20 md:w-28 h-28 md:h-40 rounded-lg overflow-hidden bg-background-200/20 border border-white/10 hover:border-white/30 transition-all duration-300 hover:-translate-y-2 cursor-pointer">
            <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20fantasy%20illustration%2C%20beautiful%20female%20warrior%20character%20design%2C%20warm%20dramatic%20lighting%2C%20manga%20style%2C%20clean%20simple%20background%2C%20professional%20comic%20cover&width=224&height=320&seq=hero-thumb-01&orientation=portrait" alt="热门韩漫封面 1" title="热门韩漫推荐 1" className="w-full h-full object-cover object-top" loading="lazy" />
          </div>
          <div className="w-20 md:w-28 h-28 md:h-40 rounded-lg overflow-hidden bg-background-200/20 border border-white/10 hover:border-white/30 transition-all duration-300 hover:-translate-y-2 cursor-pointer">
            <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20romance%20style%2C%20elegant%20couple%20in%20modern%20setting%2C%20soft%20warm%20lighting%2C%20manga%20illustration%2C%20clean%20simple%20background%2C%20professional%20comic%20cover&width=224&height=320&seq=hero-thumb-02&orientation=portrait" alt="热门韩漫封面 2" title="热门韩漫推荐 2" className="w-full h-full object-cover object-top" loading="lazy" />
          </div>
          <div className="w-20 md:w-28 h-28 md:h-40 rounded-lg overflow-hidden bg-background-200/20 border border-white/10 hover:border-white/30 transition-all duration-300 hover:-translate-y-2 cursor-pointer">
            <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20action%20style%2C%20cool%20male%20hunter%20with%20weapon%2C%20dramatic%20pose%2C%20dark%20atmospheric%20lighting%2C%20manga%20illustration%2C%20clean%20simple%20background%2C%20professional%20comic%20cover&width=224&height=320&seq=hero-thumb-03&orientation=portrait" alt="热门韩漫封面 3" title="热门韩漫推荐 3" className="w-full h-full object-cover object-top" loading="lazy" />
          </div>
          <div className="w-20 md:w-28 h-28 md:h-40 rounded-lg overflow-hidden bg-background-200/20 border border-white/10 hover:border-white/30 transition-all duration-300 hover:-translate-y-2 cursor-pointer">
            <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20school%20life%20style%2C%20young%20students%20with%20bright%20expressions%2C%20warm%20sunlight%2C%20manga%20illustration%2C%20clean%20simple%20background%2C%20professional%20comic%20cover&width=224&height=320&seq=hero-thumb-04&orientation=portrait" alt="热门韩漫封面 4" title="热门韩漫推荐 4" className="w-full h-full object-cover object-top" loading="lazy" />
          </div>
          <div className="w-20 md:w-28 h-28 md:h-40 rounded-lg overflow-hidden bg-background-200/20 border border-white/10 hover:border-white/30 transition-all duration-300 hover:-translate-y-2 cursor-pointer">
            <img src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20thriller%20mystery%20style%2C%20detective%20in%20rainy%20city%2C%20noir%20atmosphere%2C%20manga%20illustration%2C%20clean%20simple%20background%2C%20professional%20comic%20cover&width=224&height=320&seq=hero-thumb-05&orientation=portrait" alt="热门韩漫封面 5" title="热门韩漫推荐 5" className="w-full h-full object-cover object-top" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}